import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const ExpertModeTooltip = () => {
  const { t } = useTranslation()

  return (
    <TooltipBase>
      {t('Bypasses confirmation modals and allows high slippage trades. Use at your own risk.')}
    </TooltipBase>
  )
}
